import { formatDate } from "./formatDate";

const MEMBERSHIP_PERIOD_DATE_PATTERN = "MMM d, yyyy";

/**
 * Formats the membership coverage window shown on renewable-fee invoices.
 * Returns null when the span cannot be determined.
 */
export const formatInvoiceMembershipPeriod = ({
  periodStart,
  periodEnd,
  fallbackEndDate,
}: {
  periodStart?: string | null;
  periodEnd?: string | null;
  fallbackEndDate?: string | null;
}): string | null => {
  if (periodStart && periodEnd) {
    return `${formatDate(periodStart, MEMBERSHIP_PERIOD_DATE_PATTERN)} to ${formatDate(periodEnd, MEMBERSHIP_PERIOD_DATE_PATTERN)}`;
  }
  if (fallbackEndDate) {
    return formatDate(fallbackEndDate, MEMBERSHIP_PERIOD_DATE_PATTERN) || null;
  }
  return null;
};
